export enum FileSizeEnum {
  TAMANHO_ARQUIVO_DEFAULT = 10737418240 // Valores em bytes; (10GB)
}
